import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { BannerDto } from '../shared/dto/banner.dto';
import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { ProfileRead } from 'src/app/profiles/shared/profile-read.model';
import { NotificationService } from 'src/app/shared';
import { Image } from 'src/app/config/shared/image/image.model';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-banner-ad-edit',
  templateUrl: './banner-ad-edit.component.html',
  styleUrls: ['./banner-ad-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class BannerAdEditComponent implements OnInit {
  @Input()
  get banner() {
    return this._banner;
  }
  set banner(value: BannerDto) {
    this._banner = value;
    if (value?.ProfileId) {
      this.loadProfile(value.ProfileId);
    }
    this.setDefaultProperties();
    this.bannerChange.emit(this._banner);
  }
  @Output() bannerChange: EventEmitter<BannerDto> = new EventEmitter();

  profile: ProfileRead;
  imageSelectorUrl: string;
  private _banner: BannerDto;
  constructor(private _profileService: ProfileService, private _notificationService: NotificationService) {}

  ngOnInit(): void {}

  onImageChangedOrSelected(image: Image) {
    if (image?.RelativePath) {
      this.banner.ImageUrl = image?.RelativePath;
    }
  }

  private loadProfile(id: number) {
    this._profileService
      .getProfile(id)
      .then((profile) => {
        this.profile = profile;
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  private setDefaultProperties() {
    if (!this.banner) {
      return;
    }

    if (!this.banner.BannerId) {
      this.banner.ProfileId = this.banner.ProfileId ?? 0;
    } else {
      this.imageSelectorUrl = this.banner.ImageUrl;
    }
  }
}
